import React from "react";
import Layout from "components/Layout";
import Widget from "components/Widget";
import CategoryTable from "components/Table/List";
import DeleteConfirm from "components/Modal/DeleteConfirm";
import EditModal from "./components/EditCategory";
import TableAction from "components/Table/Actions/ActionDropdown";
import AddCategory from "./components/AddCategory";
import ShowModal from "components/Modal/ShowModal";
import UploadCSV from "components/uploadCSV";
import SearchBox from "components/Filters/SearchBox";
import { Tag } from "antd";
const Category = () => {
  const columns = [
    {
      title: "Category Name",
      render: (record) => <span>{record.categoryName}</span>,
      key: "categoryName",
    },
    {
      title: "",
      render: (record) => <TableAction menu={renderActions(record)} />,
      key: "action",
      width: "50px",
    },
  ];

  const renderActions = (record) => {
    return (
      <div className="gx-d-flex gx-flex-column">
        <ShowModal
          record={record}
          modalName={"EditCategory_Modal"}
          buttonName="Edit"
        />
        <DeleteConfirm
          type="deleteExerciseCatagory"
          method="DELETE"
          selectedItem={record}
          apiRequest="DeleteRecord"
          recordName="exerciseCategoryList"
          oKText="Delete"
          title="Are you sure you want to delete this Category?"
          Icon="Delete"
        />
      </div>
    );
  };

  return (
    <Layout>
      <Widget
        styleName="mainTable"
        title={
          <div className="gx-d-flex gx-flex-column">
            <span>Category</span>
            <a
              className="gx-m-0"
              href="https://painles.s3.amazonaws.com/1654281444496-categoryName-1%20-%20Sheet1.csv"
            >
              <Tag className="gx-m-0" color="blue">
                Download CSV Sample
              </Tag>
            </a>
          </div>
        }
        extra={
          <div className="gx-d-flex" style={{ gap: "20px" }}>
            <SearchBox
              apiName="getExerciseCategory"
              recordName="exerciseCategoryList"
              requestType="FetchRecord"
              customQuery={{ query: "search", key: "name" }}
              placeholder="Search By Name"
              width="200px"
            />
            <UploadCSV
              type="getExerciseCategory"
              url="bulkImportSkills"
              table="ExerciseCategory"
              recordName="exerciseCategoryList"
              cb="categoryName"
              uId="categoryId"
            />
            <AddCategory />
          </div>
        }
      >
        <CategoryTable
          apiName="getExerciseCategory"
          recordName="exerciseCategoryList"
          scroll={true}
          pagination={true}
          columns={columns}
        />
      </Widget>
      <EditModal />
    </Layout>
  );
};
export default Category;
